<template>
  <div class="set_team">
    <el-form :model="setTeam" :rules="rules" ref="setTeam" label-width="100px">
      <el-form-item label="团队头像：" prop="icon">
        <el-upload
          class="uploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="(file) => upload(file, 'icon')"
        >
          <el-image
            class="upload_img"
            v-if="setTeam.icon"
            :src="setTeam.icon"
            fit="cover"
          ></el-image>
          <i v-else class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="团队名称：" prop="name">
        <el-input
          v-model="setTeam.name"
          placeholder="请输入团队名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="岗位名称：" prop="postId">
        <el-select v-model="setTeam.postId" placeholder="请选择岗位">
          <el-option
            v-for="item in postList"
            :key="item.postId"
            :label="item.name"
            :value="item.postId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-top: 60px">
        <el-button class="btn" type="primary" @click="submitForm('setTeam')"
          >提交</el-button
        >
        <el-button class="btn" @click="resetForm('setTeam')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { postList } from "@/api/post";
import { addTeam } from "@/api/team";
import upload from "@/utils/uploadMethod";
export default {
  name: "setTeam",
  data() {
    return {
      postList: [],
      setTeam: {
        icon: "",
        postId: "",
        name: "",
        classId: this.$route.query.id,
      },
      rules: {
        icon: {
          required: true,
          message: "请上传头像",
          trigger: "blur",
        },
        name: {
          required: true,
          message: "请填写团队名称",
          trigger: "blur",
        },
        postId: {
          required: false,
          message: "请选择职务",
          trigger: "blur",
        },
      },
    };
  },
  created() {
    this.getPostList();
  },
  methods: {
    // 岗位列表
    getPostList() {
      postList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.postList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //上传图片
    async upload(file, str) {
      const fileUrl = await upload(file);
      this.setTeam[str] = fileUrl;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$loading.show();
          addTeam(this.setTeam).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("创建成功");
              this.$store.commit("SET_UPDATE", true);
              this.$router.go(-1);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("back", 0);
    },
  },
};
</script>

<style lang="less" scoped>
.set_team {
  .uploader {
    width: 104px;
    height: 104px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #409eff;
    }

    .el-icon-plus {
      font-size: 28px;
      color: #8c939d;
      width: 104px;
      height: 104px;
      line-height: 104px;
      text-align: center;
    }

    .upload_img {
      width: 104px;
      height: 104px;
      display: block;
    }
  }

  .el-select {
    width: 100%;
  }

  .btn {
    margin-right: 60px;
    width: 97px;
    height: 40px;
  }
}
</style>